export const isMaskedFee = (value) => typeof value === 'string' && value === '[masked]';

export const formatFeeDisplay = (
  value,
  { currency = '₹', decimals = false, hiddenLabel = 'Hidden' } = {}
) => {
  if (typeof value !== 'number' || Number.isNaN(value)) return hiddenLabel;

  const formatted = value.toLocaleString('en-IN', decimals
    ? { minimumFractionDigits: 2, maximumFractionDigits: 2 }
    : undefined);

  return `${currency}${formatted}`;
};

export const isMaskedDocValue = (value) => typeof value === 'string' && value === '[uploaded]';

export const isMaskedAadhar = (value) => typeof value === 'string' && (value.includes('*') || value.toUpperCase().includes('X'));

export const getEditableAadharValue = (value) => isMaskedAadhar(value) ? '' : (value || '');

export const formatAadharDisplay = (value) => {
  if (!value) return '—';
  if (isMaskedAadhar(value)) return value;
  return `XXXXXXXX${String(value).slice(-4)}`;
};
